import React, {
	useState,
	useContext,
	useEffect,
	useLayoutEffect,
	useRef,
} from "react";

// import FacebookLogin from "react-facebook-login";
import { BASE_URL } from "../env";
import { ModalContext } from "../Context/ModalContext";
import { useHistory } from "react-router-dom";
import styles from "../Assets/css/signup.module.css";
import { AuthContext } from "../Context/AuthContext";
// import ReactNotification from "react-notifications-component";
import { Store } from "react-notifications-component";

import "../Assets/css/notify-popup-theme.css";
import ETImage from "../Pages/AdminPanel/Assets/Images/ET3.png";
import LiveLogo from "../Pages/AdminPanel/Assets/Images/Live_logo.svg";
// import MainLogo from "../Assets/img/cantileverlogoblack.png";
import Navbar from "../components/Navbar";
import "react-notifications-component/dist/theme.css";
const SignIn = () => {
	// const matches = useMedia("(min-width : 768px )");
	// const [login, setLogin] = useState(false);
	// const [data, setData] = useState({});
	// const [picture, setPicture] = useState("");

	let { open, update_status } = useContext(ModalContext);
	let { update_token } = useContext(AuthContext);
	const [modal, setModal] = useState(false);
	const [email, setEmail] = useState("");
	const [password, setPassword] = useState("");
	const [load, setLoad] = useState(false);
	const [render, setRender] = useState(false);
	const [error, setError] = useState(false);
	const [errmsg, setErrmsg] = useState("");
	const [route, setRoute] = useState("");
	const pwdRef = useRef();
	const history = useHistory();

	// const [FirstName, setFirstName] = useState("");
	// const [LastName, setLastName] = useState("");
	// const [EMAILG, setEMAILG] = useState("");
	// const [PASSWORDG, setPASSWORDG] = useState("");
	var emails = "";
	var tok = "";
	// var pass = "";
	var firstnames = "";
	var lastnames = "";
	var authmethod = "";

	// let text = false;

	if (
		history.location.state != undefined &&
		Object.keys(history.location.state).find(
			(element) => element === "fromPT"
		)
	) {
		// text = true;
	}
	function handleEmail(event) {
		let e = event.target.value;
		setEmail(e.toLowerCase());
	}

	// const responseFacebook = async (response) => {
	// 	console.log(response);

	// 	if (response.name) {
	// 		let tik = response?.id;
	// 		emails = response.email;
	// 		const fullName = response.name;
	// 		const fullNameArray = response?.name.split(" ");
	// 		// console.log(fullNameArray);
	// 		tok = tik;
	// 		firstnames = fullNameArray[0];
	// 		lastnames = fullNameArray[fullNameArray.length - 1];
	// 		authmethod = "facebook";
	// 		console.log(emails);
	// 		console.log(tok);
	// 		console.log(firstnames);
	// 		console.log(lastnames);
	// 		googleSignIn();
	// 	}
	// };

	function handlePassword(event) {
		let p = event.target.value;
		setPassword(p);
	}

	const notifyPopup = () => {
		Store.addNotification({
			title: "Success!",
			message: "You have been Logged in!",
			type: "success",
			background: "pink",
			insert: "bottom",
			container: "bottom-right",
			animationIn: ["animate__animated", "animate__fadeIn"],
			animationOut: ["animate__animated", "animate__fadeOut"],
			dismiss: {
				duration: 3000,
				onScreen: true,
			},
		});
	};

	// function responsehandler(response) {
	//   console.log(response);
	//   console.log(response?.profileObj);
	//   console.log("N", response);
	//   let tik = response?.tokenId;
	//   let res = response?.profileObj;
	//   console.log(res.email);
	//   emails = res.email;
	//   tok = tik;
	//   firstnames = res.givenName;
	//   lastnames = res.familyName;
	//   authmethod = "google";
	//   console.log(emails);
	//   console.log(tok);
	//   console.log(firstnames);
	//   console.log(lastnames);
	//   googleSignIn();
	// }
	async function googleSignIn() {
		setLoad(true);
		await fetch(BASE_URL + "/signin", {
			method: "POST",
			body: JSON.stringify({
				id: 3,
				email: emails,
				password: tok,
				isGoogle: true,
			}),
			headers: { "content-Type": "application/json" },
		})
			.then((response) => response.json())
			.then(async (data) => {
				if (Object.keys(data).find((element) => element === "token")) {
					console.log(data);
					localStorage.setItem("token", data.token);
					update_token(data.token);
					console.log("LOg", history);
					if (
						history.location.state != undefined &&
						Object.keys(history.location.state).find(
							(element) => element === "prev"
						)
					) {
						setRoute(history.location.state.prev);
						console.log(history.location);
					} else {
						setRoute("/");
					}

					setRender(true);

					notifyPopup();
				} else {
					setError(true);
					await handleSignUp();
					console.log(data.message);
					setErrmsg(data.message);
					setLoad(true);
				}

				async function handleSignUp() {
					await fetch(BASE_URL + "/signup", {
						method: "POST",
						headers: { "content-Type": "application/json" },
						body: JSON.stringify({
							firstName: firstnames,
							lastName: lastnames,
							email: emails,
							password: tok,
							authMethod: authmethod,
						}),
					})
						.then((response) => response.json())
						.then((data) => {
							console.log(data);
							if (data.type == "success") {
								setRender(true);
								googleSignIn();
							} else {
								setError(true);
								setErrmsg(data.message);
								setLoad(false);
								// pwdRef.current.value = "";
							}
						});
				}
				setLoad(false);
				//pwdRef.current.value = "";
			});
	}
	// const location = useLocation();
	// console.log(location.pathname);

	// const urlParams = new URLSearchParams(window.location.search);
	// const myParam = urlParams.get("redirect");
	// console.log(myParam.split(" "));
	async function handleSubmit(event) {
		event.preventDefault();
		setLoad(true);
		await fetch(BASE_URL + "/signin", {
			method: "POST",
			body: JSON.stringify({
				id: 3,
				email: email,
				password: password,
				isGoogle: false,
			}),
			headers: { "content-Type": "application/json" },
		})
			.then((response) => response.json())
			.then((data) => {
				// console.log(data, "this is data");
				if (Object.keys(data).find((element) => element === "token")) {
					localStorage.setItem("token", data.token);
					const urlParams = new URLSearchParams(
						window.location.search
					);
					const myParam = urlParams.get("redirect");
					if (myParam === "" || !myParam) {
						history.push("/superAdmin");
					} else {
						history.push(myParam);
					}
					update_token(data.token);
					if (
						history.location.state != undefined &&
						Object.keys(history.location.state).find(
							(element) => element === "prev"
						)
					) {
						setRoute(history.location.state.prev);
					} else {
						setRoute("/");
					}

					setRender(true);

					notifyPopup();
				} else {
					setError(true);
					setErrmsg(data.message);
					setLoad(false);
					pwdRef.current.value = "";
				}
			});
	}

	useEffect(() => {
		update_status(!open);
		setModal();
	}, [modal]);
	useLayoutEffect(() => {
		window.scrollTo(0, 0);
	});
	return (
		<>
			<Navbar />
			<div style={{ overflowX: "hidden" }}>
				<div
					className={`container-fluid ${styles.background}`}
					style={{
						height: "100vh",
						display: "flex",
						alignContent: "center",
						overflowX: "hidden",
						background: "#fff",
					}}
				>
					<div class="row signup-form" style={{ width: "100vw" }}>
						<div
							className={`col-xl-7 col-lg-7 col-md-7 col-sm-6 ${styles.signupText}`}
						>
							{/* <div className={styles.signupTextdiv}>
                {text === false ? (
                  <h1 onClick={notifyPopup}> LearnLets! </h1>
                ) : (
                  <h1>Log In to continue </h1>
                )}

                <p>
                  Not a member{" "}
                  <a href="/signup" style={{ textDecoration: "underline" }}>
                    Sign Up
                  </a>
                </p>
              </div> */}

							{/* show live tracker image */}
							<div className={styles.signupTextdiv}>
								<div className="flex items-center">
									<img
										src={ETImage}
										alt="exam tracker"
										height={80}
										width={80}
										className="inline-block"
									/>
									<span
										className="text-2xl pl-2 flex items-end"
										style={{
											fontSize: "1.6rem",
										}}
									>
										<span className="mr-2">
											Exam Tracker{" "}
										</span>
										<img
											src={LiveLogo}
											alt="live logo"
											height={50}
											width="auto"
										/>
									</span>
								</div>
								<div></div>
							</div>
						</div>
						<div class="col-xl-3 col-lg-4 col-md-4 col-sm-5">
							<form
								className={styles.formcontainer}
								onSubmit={handleSubmit}
								style={{
									background: "#fff",
								}}
							>
								<div className={styles.formgroup}>
									<input
										onChange={handleEmail}
										type="email"
										className={`${styles.formcontrol} focus:border focus:border-[#ffc600]`}
										id="email"
										placeholder="Email"
										name="email"
										required
									/>
								</div>
								<div className={styles.formgroup}>
									<input
										ref={pwdRef}
										onChange={handlePassword}
										type="password"
										className={`${styles.formcontrol} focus:border focus:border-[#ffc600]`}
										style={{ marginBottom: "0" }}
										id="pwd"
										placeholder="Enter password"
										name="pswd"
										required
									/>
								</div>
								{/* <Link
                  to="/forgotpassword"
                  style={{
                    display: "flex",
                    flex: "row",
                    justifyContent: "flex-end",
                    fontSize: "13px",
                    marginBottom: "15px",
                  }}
                >
                  Forgot Password?
                </Link> */}
								{error === true ? (
									<div
										className={`${styles.formgroup} form-check ml-0 pl-0`}
									>
										<div
											className="form-check-label"
											htmlFor="exampleCheck1"
										>
											{errmsg}
										</div>
									</div>
								) : null}

								{load === false ? (
									<>
										{" "}
										{/* make this div as submit button */}
										<div
											onClick={handleSubmit}
											className={
												styles.signup_registerbtn__2Pn1X
											}
											style={{
												cursor: "pointer",
											}}
										>
											Submit
										</div>
										{/* <p style={{ color: "gray" }} className={styles.horizontalh}>
                      <span
                        style={{ color: "gray" }}
                        className={styles.horizontal}
                      >
                        {" "}
                        or
                      </span>
                    </p> */}
										{/* <GoogleLogin
                      clientId="671105516475-03k9jvsa3evmg1k4u5ge13alls8v9nfv.apps.googleusercontent.com"
                      render={(renderProps) => (
                        // <button onClick={renderProps.onClick} disabled={renderProps.disabled}> <p> This is my custom Google button </p> </button>

                        <button
                          onClick={renderProps.onClick}
                          // disabled={renderProps.disabled}
                          disabled={false}
                          style={{ width: matches ? "100%" : "100%" }}
                          class={styles.googlebutton}
                        >
                          <span
                            style={{ right: matches ? "20px" : null }}
                            class={styles.googlebuttonicon}
                          >
                            <svg
                              viewBox="0 0 366 372"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M125.9 10.2c40.2-13.9 85.3-13.6 125.3 1.1 22.2 8.2 42.5 21 59.9 37.1-5.8 6.3-12.1 12.2-18.1 18.3l-34.2 34.2c-11.3-10.8-25.1-19-40.1-23.6-17.6-5.3-36.6-6.1-54.6-2.2-21 4.5-40.5 15.5-55.6 30.9-12.2 12.3-21.4 27.5-27 43.9-20.3-15.8-40.6-31.5-61-47.3 21.5-43 60.1-76.9 105.4-92.4z"
                                id="Shape"
                                fill="#EA4335"
                              />
                              <path
                                d="M20.6 102.4c20.3 15.8 40.6 31.5 61 47.3-8 23.3-8 49.2 0 72.4-20.3 15.8-40.6 31.6-60.9 47.3C1.9 232.7-3.8 189.6 4.4 149.2c3.3-16.2 8.7-32 16.2-46.8z"
                                id="Shape"
                                fill="#FBBC05"
                              />
                              <path
                                d="M361.7 151.1c5.8 32.7 4.5 66.8-4.7 98.8-8.5 29.3-24.6 56.5-47.1 77.2l-59.1-45.9c19.5-13.1 33.3-34.3 37.2-57.5H186.6c.1-24.2.1-48.4.1-72.6h175z"
                                id="Shape"
                                fill="#4285F4"
                              />
                              <path
                                d="M81.4 222.2c7.8 22.9 22.8 43.2 42.6 57.1 12.4 8.7 26.6 14.9 41.4 17.9 14.6 3 29.7 2.6 44.4.1 14.6-2.6 28.7-7.9 41-16.2l59.1 45.9c-21.3 19.7-48 33.1-76.2 39.6-31.2 7.1-64.2 7.3-95.2-1-24.6-6.5-47.7-18.2-67.6-34.1-20.9-16.6-38.3-38-50.4-62 20.3-15.7 40.6-31.5 60.9-47.3z"
                                fill="#34A853"
                              />
                            </svg>
                          </span>
                          <span
                            style={{ marginRight: matches ? "10%" : null }}
                            class={styles.googlebuttontext}
                          >
                            LogIn with Google
                          </span>
                        </button>
                      )}
                      className="pl-5 pl-5"
                      buttonText="Login with google"
                      onSuccess={responsehandler}
                      cookiePolicy={"single_host_origin"}
                    />{" "}
                    <br />
                    <br />
                    <FacebookLogin
                      cssClass="btnFacebook"
                      appId="1832196643618709"
                      autoLoad={false}
                      fields="name,email,picture"
                      scope="public_profile,user_friends,email"
                      callback={responseFacebook}
                      icon="fa-facebook"
                      textButton="LogIn with Facebook"
                    /> */}
									</>
								) : (
									<button
										className={styles.registerbtn}
										type="button"
										disabled
									>
										<span
											className="spinner-border spinner-border-sm"
											role="status"
											aria-hidden="true"
										></span>
										<span className="sr-only">
											Loading...
										</span>
									</button>
								)}
								{render === true ? history.push(route) : null}
							</form>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};
export default SignIn;
